export default __webpack_public_path__ + "static/media/square-left.ee9a59e3.svg";